module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "title",
      "epub:type": "titlepage"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "title",
    attrs: {
      "id": "title"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("THE WEB"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _c('br'), _vm._v("MEANING")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("INTEGRATING SCIENCE AND TRADITIONAL WISDOM TO FIND OUR PLACE IN THE UNIVERSE")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("JEREMY LENT")]), _vm._v(" "), _c('figure', {
    staticClass: "pub"
  }, [_c('img', {
    staticClass: "w30",
    attrs: {
      "alt": "",
      "src": "images/title.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0